export const openMailtoLink = (url: string) => {
    window.location.assign(url);
};

export default openMailtoLink;
